import React from 'react';
import { COLORS } from '../../../styles/tokens';
import { MASS_ACCOUNT_LIMITS } from '../../../utils/massAccount';
import IconField, { bareInputStyle } from './IconField';

// «Utveiing og merking»: hvem massene veies ut/inn på (kundenavn og kundenr hos stedet) og hva lasset merkes med.
// Kontrollert komponent: onChange får alltid hele den nye verdien.
export default function MassAccountCard({ value, onChange, errors = {}, showErrors = false, removal = false, supplierName = '' }) {
  const set = patch => onChange({ ...value, ...patch });
  const err = key => (showErrors ? errors[key] : null);
  const place = supplierName || 'utsalget';

  const renderError = (key, id) => err(key) && (
    <div id={id} role="alert" style={styles.error}>{err(key)}</div>
  );

  return (
    <section style={styles.card} aria-labelledby="new-order-mass-account-title">
      <h3 id="new-order-mass-account-title" style={styles.title}>Utveiing og merking</h3>
      <p style={styles.help}>
        {removal ? 'Mottaket bruker dette ved veiing og fakturering.' : 'Utsalget bruker dette ved veiing og fakturering.'}
      </p>

      <IconField label={removal ? 'Veies inn på' : 'Veies ut på'} htmlFor="new-order-mass-name">
        <input
          id="new-order-mass-name"
          style={bareInputStyle}
          value={value.customerName}
          onChange={e => set({ customerName: e.target.value })}
          maxLength={MASS_ACCOUNT_LIMITS.customerName}
          placeholder="Kundenavn"
          aria-invalid={!!err('customerName')}
          aria-describedby={err('customerName') ? 'new-order-mass-name-err' : undefined}
        />
      </IconField>
      {renderError('customerName', 'new-order-mass-name-err')}

      <IconField label={`Kundenr hos ${place}`} htmlFor="new-order-mass-number" style={styles.gap}>
        <input
          id="new-order-mass-number"
          style={{ ...bareInputStyle, opacity: value.noAccount ? 0.5 : 1 }}
          value={value.customerNumber}
          onChange={e => set({ customerNumber: e.target.value })}
          maxLength={MASS_ACCOUNT_LIMITS.customerNumber}
          disabled={!!value.noAccount}
          placeholder="Kundenr"
          aria-invalid={!!err('customerNumber')}
          aria-describedby={err('customerNumber') ? 'new-order-mass-number-err' : undefined}
        />
      </IconField>
      {renderError('customerNumber', 'new-order-mass-number-err')}

      <label htmlFor="new-order-mass-no-account" style={styles.check}>
        <input
          id="new-order-mass-no-account"
          type="checkbox"
          checked={!!value.noAccount}
          onChange={e => (e.target.checked
            ? set({ noAccount: true, customerNumber: '' })
            : set({ noAccount: false }))}
        />
        Jeg har ikke kundenr (betaler på stedet)
      </label>

      <IconField label="Merk lasset med (valgfritt)" htmlFor="new-order-mass-reference" style={styles.gap}>
        <input
          id="new-order-mass-reference"
          style={{ ...bareInputStyle, fontWeight: 500 }}
          value={value.reference}
          onChange={e => set({ reference: e.target.value })}
          maxLength={MASS_ACCOUNT_LIMITS.reference}
          placeholder="F.eks. prosjekt eller adresse"
          aria-invalid={!!err('reference')}
          aria-describedby={err('reference') ? 'new-order-mass-reference-err' : undefined}
        />
      </IconField>
      {renderError('reference', 'new-order-mass-reference-err')}
    </section>
  );
}

const styles = {
  card: { background: COLORS.white, borderRadius: 16, border: `1px solid ${COLORS.border}`, padding: '14px' },
  title: { margin: 0, fontSize: 15.5, fontWeight: 700, color: COLORS.textDark },
  help: { margin: '2px 0 12px', fontSize: 12.5, color: COLORS.textMid, lineHeight: 1.35 },
  gap: { marginTop: 12 },
  check: { display: 'flex', alignItems: 'center', gap: 8, marginTop: 10, fontSize: 13.5, color: COLORS.textDark, cursor: 'pointer' },
  error: { marginTop: 5, fontSize: 12.5, fontWeight: 600, color: COLORS.dangerText },
};
